import { memo } from "react";
import Grid from "components/primitives/Grid";
import PlaylistPlayIcon from "@mui/icons-material/PlaylistPlay";
import IconButton from "components/IconButton";
import { useNavigate, useLocation } from "react-router-dom";
import AnalyticsService from "services/AnalyticsService";
import logEvent from "utils/logEvent";
import { LiveActivityFeedMeasurements } from "../LiveActivityFeedVirtualTable/LiveActivityFeedVirtualTable.utils";
import LiveActivityFeedVirtualTableRowAthleteLabel from "./components/LiveActivityFeedVirtualTableRowAthleteLabel";
import { ExerciseCardGrid } from "./components/LiveActivityFeedVirtualTableRow.components";
import LiveActivityFeedVirtualTableRowData from "./components/LiveActivityFeedVirtualTableRowData";
import ExerciseRecordingVideoItem from "components/ExerciseRecordingVideo/ExerciseRecordingVideoItem";
import ThemeProvider2024 from "components/MuiThemeProvider/ThemeProvider2024";
import Div from "components/primitives/Div";
import useRemoteConfig from "providers/RemoteConfigProvider/useRemoteConfig";
import { useTranslation } from "react-i18next";

function LiveActivityFeedVirtualTableRow(props: LiveActivityFeedMeasurements) {
  const { completedDate, measurements, athleteId } = props;
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const HUB_ENABLE_VIDEO_PLAYBACK = useRemoteConfig("HUB_ENABLE_VIDEO_PLAYBACK");

  function updateLeaderboardExercise(id: string) {
    const search = new URLSearchParams(location.search);
    search.set("exerciseId", id);

    logEvent("HUB_LIVE_SET_LEADERBOARD_EXERCISE", {
      [AnalyticsService.PROPERTIES.EXERCISE_ID]: id,
      [AnalyticsService.PROPERTIES.EVENT_CLICK_LOCATION]: "liveActivityFeed",
    });

    navigate(`${location.pathname}?${search.toString()}`);
  }
  return (
    <Grid container spacing="0px" p={0} width="calc(100% - 8px)">
      <Grid size={12} mx={1} borderRadius={0}>
        <LiveActivityFeedVirtualTableRowAthleteLabel completedDate={completedDate} athleteId={athleteId} />
      </Grid>
      <ThemeProvider2024>
        {measurements.map((measurement) => (
          <ExerciseCardGrid key={measurement.id} size={12}>
            <Grid container alignItems="center" borderRadius={0} spacing="0px" px={2} py={0.25}>
              <Grid size="grow">
                <LiveActivityFeedVirtualTableRowData {...measurement} />
              </Grid>
              <Grid flexDirection="row" display="flex" justifyContent="flex-end" alignItems="center">
                {HUB_ENABLE_VIDEO_PLAYBACK && (
                  <Div>
                    {measurement.video ? (
                      <ExerciseRecordingVideoItem measurementId={measurement.id} video={measurement.video.mux} />
                    ) : (
                      <Div aria-hidden="true" sx={{ width: 30, height: 30, mx: 1.5 }} />
                    )}
                  </Div>
                )}
                <ThemeProvider2024>
                  <Div>
                    <IconButton
                      size="small"
                      color="primary"
                      aria-label={t("live.set_leaderboard_exercise_aria_label")}
                      title={t("live.set_leaderboard_exercise_aria_label")}
                      onClick={() => updateLeaderboardExercise(measurement.exerciseId)}
                    >
                      <PlaylistPlayIcon />
                    </IconButton>
                  </Div>
                </ThemeProvider2024>
              </Grid>
            </Grid>
          </ExerciseCardGrid>
        ))}
      </ThemeProvider2024>
    </Grid>
  );
}

export default memo(LiveActivityFeedVirtualTableRow);
